import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const addFeedback = createAsyncThunk(
    "admin/addSubject",
    async (payload, { rejectWithValue }) => {
      try {
        const response = await apiInstance.post(`/feedback/add`, payload, {
          headers: authHeader(),
        });
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const getAllFeedback = createAsyncThunk(
    "admin/feedback",
    async ({ page, limit }, { rejectWithValue }) => {
      try {
        const response = await apiInstance.get(
          `/feedback/all?page=${page}&limit=${limit}`,
          {
            headers: authHeader(),
          }
        );
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const deleteFeedback = createAsyncThunk(
    "admin/deleteFeedback",
    async (selectedId, { rejectWithValue }) => {
      try {
        const response = await apiInstance.delete(
          `/feedback/delete/${selectedId}`,
          {
            headers: authHeader(),
          }
        );
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  const initialState = {};
const feedbackSlice = createSlice({
  name: "feedbackSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllFeedback.fulfilled, (state, action) => {
      state.feedbackData = action.payload.data;
    });
  },
});
export default feedbackSlice.reducer;
